import React from "react";
import Skeleton from "../../components/Skeleton/Skeleton";

const LoginSkeleton: React.FC = () => {
  return (
    <>
      <div className="text-center auth-title-form">
        <Skeleton
          width={200}
          height={20}
          className="mx-auto"
          animation={"enabled"}
        />
      </div>

      <div className="card-body">
        <div className="mb-2">
          <Skeleton
            width={100}
            height={20}
            className="mb-2"
            animation={"enabled"}
          />
          <Skeleton height={48} className="w-100" animation={"enabled"} />
        </div>

        <div className="mb-2">
          <Skeleton
            width={100}
            height={20}
            className="mb-2"
            animation={"enabled"}
          />
          <Skeleton height={48} className="w-100" animation={"enabled"} />
        </div>

        <div className="pt-3 pb-2">
          <Skeleton width={120} height={20} animation={"enabled"} />
        </div>

        <div className="text-center w-100 pb-2">
          <Skeleton
            width={200}
            height={20}
            className="mx-auto"
            animation={"enabled"}
          />
        </div>

        <div className="mb-2">
          <Skeleton height={48} className="w-100" animation={"enabled"} />
        </div>

        <div className="p-3 pb-5">
          <Skeleton
            width="100%"
            height={20}
            count={0.5}
            className="mb-2"
            animation={"enabled"}
          />
          <Skeleton
            width="100%"
            height={20}
            count={1}
            className="mb-2"
            animation={"enabled"}
          />
        </div>
      </div>
    </>
  );
};

export default LoginSkeleton;
